// Shared, module-level QueryClient. Created here so non-component code
// (e.g. AuthContext.signOut) can reset the cache on auth transitions.
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,       // 2 minutes — avoid re-fetching on every tab switch
      gcTime: 30 * 60 * 1000,          // 30 minutes — keep unused data in cache
      retry: 2,                        // Retry failed requests twice before showing error
      refetchOnWindowFocus: true,      // Re-fetch when the app returns to foreground
      refetchOnReconnect: true,        // Re-fetch when network comes back
    },
  },
});